import moment from 'moment-timezone';
import { DEFAULT_START_OFFSET } from '../calendar/calendar-items/CalendarCalculator';
import { AccountData } from '../api';

const formatDuration = (seconds: number, tFunc: any) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  let result = '';
  if (hours === 0 && minutes === 30) {
    return tFunc('duration.just_30min');
  }
  if (hours === 1) {
    result += ` ${tFunc('duration.1hr')} `;
  }
  if (hours === 2) {
    result += ` ${tFunc('duration.2hrs')} `;
  }
  if (hours > 2) {
    result += ` ${hours} ${tFunc('duration.hrs')} `;
  }
  if (minutes === 30) {
    result += tFunc('duration.30min');
  } else if (minutes > 0) {
    result += `${tFunc('duration.and')} ${minutes} ${tFunc('duration.min')}`;
  }
  return result;
};
export const isSummerTime = (account: AccountData) => {
  return moment.tz(moment(), account.timezone).isDST();
};
// Set the wall-clock hour instead of adding elapsed hours, so a DST change today doesn't shift the labels
const getAllDayHours = (account: AccountData) => {
  const today = moment()
    .tz(account.timezone || 'utc')
    .startOf('day');
  const result = [];
  for (let hour = DEFAULT_START_OFFSET; hour < 24; hour++) {
    result.push(today.clone().hour(hour));
  }
  return result;
};

const getLocalTime = (utcTimeString: string, timeZone: string): moment.Moment => {
  return moment.utc(utcTimeString).tz(timeZone);
};
const TimeUtils = {
  formatDuration,
  getAllDayHours,
  getLocalTime,
};

export default TimeUtils;
